import React from 'react';
import App from '../App';

function Obracun() {
  return <App />;
}

export default Obracun;

